import { Model } from '@vuex-orm/core';
// eslint-disable-next-line import/no-cycle
import Task from '@/modules/task/store/model';

class Event extends Model {
  static entity = 'events';

  static fields() {
    return {
      id: this.attr(null),
      type: this.attr(null),
      timestamp: this.attr(null),
      approvedBy: this.attr(null),
      click: this.attr(null),
      taskId: this.attr(null),
      task: this.belongsTo(Task, 'taskId'),
      notes: this.attr([]),
    };
  }

  static apiConfig = {
    actions: {
      fetchByTaskId(id, from, to) {
        return this.get(`tasks/${id}/events`, {
          params: {
            from,
            to,
            includeNotes: true,
          },
          dataTransformer: ({ data }) => data
            .map((item) => ({ ...item, taskId: id })),
        });
      },
      approveDeviation(id) {
        return this.post('deviations/approve', { id });
      },
      addNote(id, note) {
        return this.post(`events/${id}/notes`, { text: note }, { save: false });
      },
      getNotes(id) {
        return this.get(`events/${id}/notes`, {
          save: false,
        });
      },
    },
  }
}

export default Event;
